export const fmtMoney = (n) => {
  if (n == null || isNaN(n)) return "—";
  if (Math.abs(n) >= 1_000_000) return `$${(n / 1_000_000).toFixed(2)}M`;
  if (Math.abs(n) >= 1_000) return `$${(n / 1_000).toFixed(0)}K`;
  return `$${n.toFixed(0)}`;
};
export const fmtMoneyFull = (n) => {
  if (n == null || isNaN(n)) return "—";
  return `$${Math.round(n).toLocaleString("en-US")}`;
};
export const fmtPct = (n) => (n == null || isNaN(n) ? "—" : `${Number(n).toFixed(1)}%`);
export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-US", { month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
};

export const STAGES = [
  { key: "new_leads", label: "New Leads", accent: "#a1a1aa" },
  { key: "offer_sent", label: "Offer Sent", accent: "#3b82f6" },
  { key: "under_review", label: "Under Review", accent: "#f59e0b" },
  { key: "hot_deals", label: "HOT Deals", accent: "#10b981" },
];

export const ALL_STAGES = [
  ...STAGES,
  { key: "archived", label: "Archived", accent: "#52525b" },
];

export const TYPE_STYLE = {
  Land: { bg: "rgba(251,146,60,0.12)", fg: "#fb923c", border: "rgba(251,146,60,0.35)" },
  Residential: { bg: "rgba(96,165,250,0.12)", fg: "#60a5fa", border: "rgba(96,165,250,0.35)" },
  Commercial: { bg: "rgba(148,163,184,0.14)", fg: "#cbd5e1", border: "rgba(148,163,184,0.35)" },
};
